import React from 'react';
import './ChckBxAccR1.css';
import tr from '../../../libs/tr'

class ChckBxAccR1 extends React.Component {
    constructor(props) {
        super();

        this.state = {
            checkBox1: true,
            context1: props.context1,
        };

        console.log("props.context1 son", props.context1)


    };

    // componentWillReceiveProps(nextProps) {
    //     const { checkBox1 } = nextProps;
    //     this.setState({ checkBox1 });
    //     }

    activeButton = () => {
        this.setState({ checkBox1: !this.state.checkBox1 })
        console.log("Amid checkbox", this.state.checkBox1)
        this.props.controller(this.state.checkBox1);

    }

    render() {
        return (
            <div>
                <label className="containerchtbr" onChange={this.activeButton}>{this.state.context1}
                    <input type="checkbox" />
                    <span className="checkmarkR"></span>
                </label>
            </div>
        );
    }
}

export default ChckBxAccR1;


// WEBPACK FOOTER //
// ./src/assets/components/checkbox/ChckBxAccR1.js